<div class="sso-login">
  @if (kirjautuminenKaynnissa() && !roolinValintaKaynnissa()) {
    <div style="text-align: center">Kirjaudutaan...</div>
  }
  @if (commonError() && !kirjautuminenKaynnissa()) {
    <div class="red-text common-error" style="vertical-align: middle">{{ commonError() }}</div>
  }

  @if (roolinValintaKaynnissa()) {
    <div>
      <lemon-dialog-header [naytaSuljeRuksi]="false" style="padding-top: 1rem; padding-bottom: 0">Valitse rooli</lemon-dialog-header>
      <div style="padding: 2rem">
        <p>Valitse, millä roolilla haluat kirjautua sisään:</p>
        <mat-form-field>
          <mat-label>Rooli</mat-label>
          <mat-select required [(value)]="valittuRooli">
            @for (rooli of roolit; track rooli) {
              <mat-option [value]="rooli">
                {{ rooli.nimi }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div style="margin-top: 1rem">tai kirjaudu tilintarkastajana:</div>
        <mat-form-field>
          <input matInput [formField]="tilintarkastajaAvain" placeholder="Tilintarkastajan avain" />
        </mat-form-field>
        <div style="display: flex; flex-direction: row; justify-content: center; margin-top: 1.5rem; gap: 0.5rem">
          <div style="margin-top: 1rem">
            <button class="secondarybutton" mat-button type="button" (click)="onCancel()" [disabled]="kirjautuminenKaynnissa()">Peruuta</button>
          </div>
          <div style="margin-top: 1rem">
            <button class="primarybutton" mat-button type="button" (click)="kirjaudu()" [disabled]="kirjautuminenKaynnissa()">Kirjaudu</button>
          </div>
        </div>
      </div>
    </div>
  }

  @if (!kirjautuminenKaynnissa() && !roolinValintaKaynnissa() && !useammanTilinLinkitysKaynnissa()) {
    <div class="sso-login-container">
      <lemon-dialog-header [naytaSuljeRuksi]="false">Tunnistautuminen</lemon-dialog-header>
      <button type="button" (click)="kirjauduProviderilla('microsoft')" [disabled]="kirjautuminenKaynnissa()" class="sso-login-button microsoft-button" aria-label="Kirjaudu Microsoft-tilillä">
        <span class="icon-wrapper">
          <img src="../../assets/icons/microsoft.svg" alt="Microsoft logo" class="icon" />
        </span>
        <span class="button-text"> Kirjaudu Microsoftilla </span>
      </button>
      <div style="margin-top: 2rem; margin-bottom: 1rem">
        <button class="secondarybutton" mat-button type="button" (click)="onCancel()" [disabled]="kirjautuminenKaynnissa()">Peruuta</button>
      </div>
    </div>
  }

  @if (useammanTilinLinkitysKaynnissa() && !kirjautuminenKaynnissa()) {
    <div style="padding: 2rem">
      <p>Tilisi linkitettiin Microsoft-tunnistautumiseen. Ole hyvä ja kirjaudu uudelleen.</p>
      <div style="display: flex; flex-direction: row; justify-content: center; margin-top: 1.5rem; gap: 0.5rem">
        <div style="margin-top: 1rem">
          <button class="secondarybutton" mat-button type="button" (click)="onCancel()" [disabled]="kirjautuminenKaynnissa()">Kirjaudu uudelleen</button>
        </div>
      </div>
    </div>
  }
</div>
